import { useEffect } from 'react';

import * as Sentry from '@sentry/react';

import type { ActiveUserProfile } from '@ll-platform/frontend/core/auth/types';
import { useOptionalActiveOrganization } from '@ll-platform/frontend/core/organization/ActiveOrganizationProvider';

export function useSentrySyncContext(activeUser?: ActiveUserProfile) {
  const { activeOrganization } = useOptionalActiveOrganization();

  useEffect(() => {
    if (activeUser) {
      Sentry.setUser({
        id: activeUser._id,
        email: activeUser.email,
        username:
          `${activeUser.firstName ?? ''} ${activeUser.lastName ?? ''}`.trim(),
        accountType: activeUser.accountType,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [activeUser]);

  useEffect(() => {
    if (activeOrganization) {
      Sentry.setTag('organization_id', activeOrganization.id);
      Sentry.setContext('Organization', {
        id: activeOrganization.id,
        name: activeOrganization.name,
        domain: activeOrganization.domain,
      });
    } else {
      Sentry.setTag('organization_id', null);
      Sentry.setContext('Organization', null);
    }
  }, [activeOrganization]);
}
